var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 294,
    viewBox: "0 0 451 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4648 163.325C86.614 160.652 85.6892 158.498 84.954 156.939C84.0338 154.997 83.1645 153.185 81.6016 151.076C79.9416 148.833 78.9335 147.469 76.9961 146.471C74.5176 145.194 72.1177 145.342 71.0265 145.426C68.8578 145.587 67.1377 146.406 63.6974 148.043C61.8895 148.903 62.6894 148.653 58.4631 150.868C57.2608 151.497 55.9568 152.167 54.3801 153.379C52.6461 154.711 51.9386 155.663 51.8693 156.731C51.8323 157.263 51.971 157.651 52.0773 157.989C52.4426 159.122 52.8542 160.819 53.0206 163.223",
    fill: "#F8EC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.587 163.954C442.199 157.212 442.763 151.834 443.373 148.094C444.266 142.633 445.26 140.681 444.159 137.727C442.509 133.315 437.825 131.082 433.64 129.089C428.96 126.86 427.8 127.549 422.177 124.849C420.632 124.109 417.835 122.671 414.64 120.451C407.898 115.772 408.023 113.608 403.806 112.128C400.634 111.014 397.85 111.286 394.068 111.656C388.981 112.151 385.171 113.686 383.701 114.324C380.478 115.73 380.704 116.243 376.478 118.25C372.686 120.049 370.786 120.951 368.155 121.39C363.179 122.222 360.604 120.682 359.045 122.49C357.954 123.757 358.99 124.779 357.945 126.888C356.521 129.755 353.853 129.376 351.508 131.914C350.264 133.26 349.77 135.71 348.84 140.552C348.285 143.437 347.647 146.794 347.323 151.543C347.111 154.641 347.009 158.585 347.323 163.163",
    fill: "#F8EC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.538 163.117C324.299 159.829 324.433 157.415 324.808 155.788C325.164 154.239 325.644 153.823 326.38 151.284C326.939 149.342 327.452 147.58 327.425 145.629C327.388 142.743 326.19 140.677 324.387 137.569C322.463 134.249 322.13 134.836 319.989 131.29C317.687 127.47 317.779 126.301 315.698 124.067C313.946 122.185 312.147 121.154 311.301 120.715C310.265 120.178 307.07 118.574 303.028 118.934C300.421 119.166 300.596 119.938 296.014 120.923C293.207 121.529 291.764 121.824 289.836 121.552C289.254 121.468 288.37 121.297 284.079 119.457C280.741 118.024 280.264 117.695 279.159 117.261C275.289 115.739 271.696 116.095 269.421 116.317C263.415 116.909 262.485 119.156 252.724 122.338C248.553 123.697 246.463 124.377 244.715 124.382C244.294 124.382 243.124 124.358 241.733 124.853C241.733 124.853 240.318 125.357 239.065 126.425C237.224 127.993 236.716 143.664 238.121 165.059",
    fill: "#F8EC30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.715 162.382C215.006 158.71 214.627 156.25 214.4 153.587C213.831 146.845 215.006 147.557 214.243 145.264C212.643 140.459 208.565 140.552 204.505 133.644C203.622 132.141 203.881 132.247 202.618 130.032C200.033 125.482 198.739 123.207 196.339 121.552C193.023 119.268 189.338 119.221 187.544 119.198C184.552 119.161 183.766 119.873 180.478 120.299C176.229 120.844 172.988 120.234 169.173 119.513C161.77 118.116 159.911 116.1 155.509 116.845C152.734 117.312 149.854 118.417 149.854 118.417C147.912 119.161 147.74 119.448 146.085 120.146C144.097 120.979 140.439 122.514 136.356 122.033C133.489 121.695 130.507 120.752 128.777 123.748C125.208 129.931 124.926 139.881 125.041 146.845C125.296 162.123 124.81 162.202 125.513 163.334C128.944 168.879 139.87 165.929 155.352 165.064C185.828 163.362 212.509 170.946 214.4 165.064C214.534 164.643 214.594 163.894 214.715 162.396V162.382Z",
    fill: "#F8EC30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1758 164.268C85.8706 163.279 85.3712 161.947 84.525 160.5C82.791 157.531 80.6593 155.852 80.049 155.395C78.7635 154.424 76.3729 152.625 72.9835 152.334C71.1385 152.176 69.5016 152.648 66.2324 153.591C63.6384 154.34 61.8813 155.108 60.3415 155.788C55.7359 157.827 55.0146 158.904 54.7649 159.32C53.7569 160.999 53.743 162.987 53.743 163.089C53.743 163.838 53.8632 164.458 53.9788 164.897",
    fill: "#F8EC30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.5493 89.5166H447.301V166.123H33.5493V89.5166Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.976 164.74C440.128 159.232 440.132 154.669 439.92 151.547C439.633 147.367 439.388 144.348 437.252 141.652C435.573 139.543 433.474 138.559 430.343 137.412C420.231 133.699 412.282 132.857 412.282 132.857C402.604 131.831 403.108 133.227 393.125 132.385C381.347 131.396 379.276 129.338 374.906 131.442C369.963 133.824 371.461 137.014 364.539 141.18C361.233 143.173 357.016 144.773 354.329 147.15C354.061 147.39 352.554 148.741 350.404 150.447C349.52 151.145 349.164 151.399 348.989 151.547C347.689 152.625 346.834 155.57 348.831 163.796",
    fill: "#F8EC30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.547 163.796C323.209 161.184 322.497 157.48 320.879 153.277C319.616 150.012 318.595 147.353 316.481 144.953C313.749 141.851 311.081 141.319 302.503 138.36C289.819 133.981 291.66 133.754 286.485 132.547C278.768 130.749 272.674 130.781 269.053 130.818C264.142 130.873 261.058 130.933 257.118 132.233C254.33 133.153 254.927 133.435 248.952 135.844C245.614 137.19 244.037 137.666 242.359 139.298C240.537 141.069 239.806 143.025 239.376 144.167C236.518 151.778 239.297 164.143 239.691 165.84",
    fill: "#F8EC30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.992 163.01C212.396 160.869 211.508 158.284 210.167 155.473C209.792 154.692 208.414 151.857 205.769 148.093C201.478 141.985 199.333 138.933 195.717 137.883C194.066 137.407 192.314 137.407 188.809 137.412C184.652 137.416 184.411 137.934 182.529 137.569C178.742 136.838 178.849 134.591 174.678 133.014C171.459 131.798 168.426 132.015 165.411 132.228C164.19 132.316 162.609 132.598 159.442 133.171C152.381 134.443 152.621 134.739 150.804 134.744C145.782 134.758 144.913 132.519 142.009 133.486C140.303 134.055 140.784 134.767 136.197 139.455C133.862 141.846 133.117 142.29 129.76 145.735C128.105 147.437 127.272 148.287 126.935 148.717C125.631 150.377 123.536 154.525 126.935 164.735",
    fill: "#F8EC30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7085 57.1666V165.84H448.555V57.1666V0",
    stroke: "white",
    strokeWidth: 4.62401,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M448.555 100.822H422.489V89.5166H347.423V100.822H320.724V89.5166H238.121V100.822H210.793V89.5166H124.107V100.822H99.9231V89.5166H32.7085",
    stroke: "white",
    strokeWidth: 4.62401,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M347.316 165.84V102.186",
    stroke: "white",
    strokeWidth: 4.62401,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.117 165.84V102.186",
    stroke: "white",
    strokeWidth: 4.62401,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.102 165.84V102.186",
    stroke: "white",
    strokeWidth: 4.62401,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M291.828 53.2412H91.5994",
    stroke: "#F8EC30",
    strokeWidth: 2.312,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M446.043 166.778H349.776",
    stroke: "#F8EC30",
    strokeWidth: 6.93601,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M326.898 166.778H240.628",
    stroke: "#F8EC30",
    strokeWidth: 6.93601,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.715 166.778H126.721",
    stroke: "#F8EC30",
    strokeWidth: 6.93601,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5625 166.778H52.0294",
    stroke: "#F8EC30",
    strokeWidth: 6.93601,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.707 168.152V292.529H0.00144266",
    stroke: "#F8EC30",
    strokeWidth: 2.312,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.594 73.6562H121.594V98.3115H102.594V73.6562Z",
    fill: "#17375E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M213.308 73.6562H235.711V98.3115H213.308V73.6562Z",
    fill: "#17375E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M323.075 73.6562H345.062V98.575H323.075V73.6562Z",
    fill: "#17375E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M424.056 73.6562H446.043V98.575H424.056V73.6562Z",
    fill: "#17375E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.1b7a21d07e01e0e7a904ead48b7dedcf.svg";
export { ForwardRef as ReactComponent };